import React, { useMemo } from 'react';
import { Table } from 'antd';
import { getArchivedReportsTableData } from '../utils';
import { ArchivedReportsTableData, SavedAnalysisOverview } from '../types';

const { Column } = Table;

type Props = {
    websiteUrl: string;
    overviews: SavedAnalysisOverview[];
};

export default function ArchivedReportOverviewsTable({ websiteUrl, overviews }: Props) {
    const tableDataSource = useMemo(() => getArchivedReportsTableData(overviews), [overviews]);

    return (
        <Table
            className="archived-reports-table"
            dataSource={tableDataSource}
            size="small"
            pagination={false}
        >
            <Column
                title="#"
                dataIndex="key"
                align="left"
                width="50px"
            />
            <Column
                title="Created at"
                dataIndex="createdAt"
            />
            <Column
                className="no-wrap"
                title="Score"
                dataIndex="score"
                align="right"
            />
            <Column
                className="no-wrap"
                title="Passed"
                dataIndex="passed"
                align="right"
            />
            <Column
                className="no-wrap"
                title="Failed"
                dataIndex="failed"
                align="right"
            />
            <Column
                className="no-wrap"
                title="Warnings"
                dataIndex="warning"
                align="right"
            />
            <Column
                className="no-wrap view-saved-report"
                title="Action"
                dataIndex="viewReport"
                align="right"
                render={(_, record: ArchivedReportsTableData) => (
                    <a
                        href={`/analysis/report?guid=${record.guid}&url=${websiteUrl}`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        View report
                    </a>
                )}
            />
        </Table>
    );
}
